<template>
  <div id="adopt">
    <div class="notices">得宠上已发布了{{ sendCount }}只宠物领养信息</div>
    <div class="swiper-wrapper">
      <van-swipe :autoplay="5000" class="swiper-content">
        <van-swipe-item
          v-for="(image, index) in imgList"
          :key="index"
          class="img-wrapper"
        >
          <div class="img-wrapper">
            <img
              class="slide-image"
              :src="image.pre"
              @click="previewImage(index)"
            />
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div :class="optionsClass">
      <div class="options-content">
        <div class="category-wrapper options-item" @click="showArea">
          <span>{{ region[0] }}</span>
          <span class="icon"></span>
        </div>
        <div
          class="category-wrapper options-item"
          @click="optionSelect('animalList')"
        >
          <span>品种/{{ animalList[animalListSelect].value }}</span>
          <span class="icon"></span>
        </div>
        <div
          class="category-wrapper options-item"
          @click="optionSelect('statusList')"
        >
          <span>领养状态/{{ statusList[statusListSelect].value }}</span>
          <span class="icon"></span>
        </div>
      </div>
      <van-popup
        v-model="areaShow"
        position="bottom"
        :style="{ height: '40%' }"
      >
        <van-area
          :area-list="areaList"
          :columns-num="2"
          @cancel="areaCancel"
          @confirm="areaConfirm"
        />
      </van-popup>
      <div v-show="!hideList" class="filter-list">
        <div class="list-wrapper">
          <div
            v-for="(item, itemIndex) in list"
            :key="itemIndex"
            class="list-item"
          >
            <div
              class="filter-item"
              :class="{ active: itemIndex === selectedIndex }"
              @click="eventSelectedIndex(itemIndex)"
            >
              <span class="name">{{ item.value }}</span>
              <span class="icon"></span>
            </div>
            <div class="separator"></div>
          </div>
        </div>
      </div>
    </div>
    <div :class="listClass">
      <van-list
        v-model="listLoading"
        :finished="listFinished"
        :offset="100"
        finished-text="没有更多了"
        @load="listLoad"
      >
        <div
          v-for="(item, index) in petList"
          :key="index"
          class="list-item"
          @click="navToDetail(item.item_id)"
        >
          <div class="top-wrapper">
            <div class="pet-info">
              <div class="avatar">
                <img class="dog-avatar" :src="item.avatar || item.picture[0]" />
              </div>
              <div class="info-text">
                <div v-if="item.gender === 'MM'" class="title female">
                  {{ item.title || item.breeding }}
                </div>
                <div v-else-if="item.gender === 'GG'" class="title male">
                  {{ item.title || item.breeding }}
                </div>
                <div v-else class="title">
                  {{ item.title || item.breeding }}
                </div>
                <div v-if="item.gender !== 0" class="nick">
                  {{ item.gender }} {{ item.age }}
                </div>
                <div v-else-if="item.age" class="nick">{{ item.age }}</div>
              </div>
            </div>
            <div
              v-if="item.status == '待领养'"
              class="adopt-state waiting_adopt"
            ></div>
            <div v-else class="adopt-state adopted"></div>
          </div>
          <div class="desc">{{ item.desc }}</div>
          <div class="img-list">
            <img
              v-for="(pic, imgIndex) in item.picture"
              :key="imgIndex"
              class="animal-picture"
              :src="pic"
            />
          </div>
          <div class="bottom">
            <div class="left">
              <span class="city">{{ item.city }}</span>
              <span class="time">{{ item.timestamp }}</span>
            </div>
            <div class="right">
              <span>{{ item.read_count }}浏览</span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <a class="bottom" href="http://www.beian.miit.gov.cn/">
      <div class="c-name">北京得宠科技</div>
      <div class="icp">京ICP备18031539号</div>
    </a>
  </div>
</template>

<script>
// @ is an alias to /src
import { petPublish, petPublishCount, getConfig } from "@/util/api";
import areaList from "@/util/address";
import publish from "@/util/publish";

export default {
  name: "List",
  components: {},
  data() {
    return {
      areaShow: false,
      areaList: areaList,
      imgList: [],
      sendCount: 0,
      region: ["全国"],
      showRegion: "全国",
      list: [],
      listFinished: false,
      listLoading: false,
      selectedIndex: 0,
      currentType: "",
      hideList: true,
      animalList: [
        { value: "不限", key: 0 },
        { value: "猫", key: 1 },
        { value: "狗", key: 2 }
      ],
      animalListSelect: 0,
      statusList: [
        { value: "不限", key: "" },
        { value: "待领养", key: 0 },
        { value: "已领养", key: 1 }
      ],
      statusListSelect: 0,
      pets: [],
      page: 1,
      empty: false,
      optionsFixed: false
    };
  },
  computed: {
    optionsClass() {
      return {
        "options-wrapper": true,
        fixed: this.optionsFixed
      };
    },
    filterItemClass() {
      return {
        "filter-item": true,
        active: false
      };
    },
    listClass() {
      return {
        list: true,
        fixed: this.optionsFixed
      };
    },
    petList() {
      return this.pets.map(item => {
        item.genderText = item.gender === 1 ? "GG" : "MM";
        return item;
      });
    },
    query() {
      let region = this.region.filter(function(elem) {
        return elem !== "不限";
      });
      let query = {
        page: this.page,
        animal: this.animalList[this.animalListSelect].key,
        status: this.statusList[this.statusListSelect].key,
        city: this.region[0] === "全国" ? [] : this.region.slice(0, 2)
      };
      if (query.animal === 0) {
        delete query.animal;
      }
      if (query.status === "") {
        delete query.status;
      }
      return query;
    }
  },
  created() {
    this._getPetList();
    this._getBannerPic();
    this._getSendCount();
  },
  methods: {
    navToDetail(item_id) {
      this.$router.push({ name: "detail", params: { item_id } });
    },

    showArea() {
      this.areaShow = true;
    },

    async areaConfirm(regionList) {
      this.region = regionList.map(item => {
        return item.name;
      });
      this.areaShow = false;
      if (this.showRegion === "不限") {
        this.showRegion = "全国";
      }
      this.page = 1;
      this.$Toast.loading({
        mask: true,
        duration: 0,
        message: "加载中..."
      });
      await this._getPetList();
      this.$Toast.clear();
    },

    areaCancel() {
      this.areaShow = false;
    },

    optionSelect(e) {
      if (this.hideList) {
        this.currentType = e;
        this.hideList = false;
        this.list = this[e];
        this.selectedIndex = this[e + "Select"];
      } else if (!this.hideList && this.list === this[e]) {
        this.hideList = true;
      } else {
        this.list = this[e];
        this.selectedIndex = this[e + "Select"];
      }
    },
    async eventSelectedIndex(index) {
      this[this.currentType + "Select"] = index;
      this.selectedIndex = this[this.currentType + "Select"];
      this.hideList = true;
      this.page = 1;
      await this._getPetList(true);
    },
    previewImage(index) {
      this.$ImagePreview({
        images: this.imgList.map(item => {
          return item.src;
        }),
        startPosition: index
      });
    },
    async listLoad() {
      this.page++;
      this.listLoading = true;
      await this._getPetList();
    },

    async _getPetList() {
      let rtnList = await petPublish(this.query);
      let length = rtnList.length;
      rtnList.map(x => publish.changeFormat(x));

      if (this.query && this.query.page > 1) {
        rtnList = this.pets.concat(rtnList);
      }
      this.pets = rtnList;
      this.listFinished = !length;
      this.listLoading = false;
    },

    _getBannerPic() {
      getConfig("rotation_picture").then(res => {
        this.imgList = res;
      });
    },

    _getSendCount() {
      petPublishCount().then(res => {
        this.sendCount = res.count;
      });
    }
  }
};
</script>

<style scoped lang="less">
@import "../common/less/variable.less";
#adopt {
  padding-top: 25px;
  background-color: #dedede;
  padding-bottom: 50px;
  image {
    width: 100%;
    height: 100%;
  }
  .notices {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100%;
    height: 25px;
    background-color: @color-theme-black;
    text-align: center;
    color: @color-theme-yellow;
    font-size: 16px;
    line-height: 25px;
  }
  .swiper-wrapper {
    height: 157px;
    overflow: hidden;
    padding: 10px 0 0;
    background-color: #fff;
    .swiper-content {
      height: 137px;
      border-radius: 10px;
      .img-wrapper {
        width: 100%;
        padding: 0 10px;
        border-radius: 10px;
        overflow: hidden;
        .slide-image {
          width: 100%;
          height: auto;
          border-radius: 10px;
        }
      }
    }
  }
  .options-wrapper {
    position: relative;
    background-color: #fff;
    &.fixed {
      position: fixed;
      top: 12px;
      left: 0;
      right: 0;
      z-index: 10;
    }
    .options-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 10px 30px;
      background-color: #fff;
      border-bottom: solid 2px #c7c7c7;
      .options-item {
        position: relative;
        font-size: 13px;
        height: 15px;
        line-height: 15px;
        text-align: center;
        color: @color-theme-black;
        /*flex: 1;*/
        display: flex;
        align-items: center;
        /*justify-content: center;*/
        font-weight: bold;
        .icon {
          margin-left: 5px;
          display: inline-block;
          width: 6px;
          height: 15px;
          content: "";
          background: url("@{img-baseurl}arrow.png") 0 0 no-repeat;
          background-size: 100% auto;
          position: relative;
          top: 1px;
          &.picker {
            top: 4px;
          }
        }
      }
    }
    .filter-list {
      position: absolute;
      top: 43px;
      left: 0;
      width: 100%;
      height: 100%;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      background: rgba(0, 0, 0, 0.28);
      z-index: 5;
      .list-wrapper {
        background: #fafafa;
        .filter-item {
          background: #fff;
          padding: 10px 0 15px 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .filter-item .name {
          font-size: 14px;
          line-height: 25px;
          color: #474747;
        }
        .filter-item .icon {
          width: 25px;
          height: 25px;
          background: url("http://resource-thefair.oss-cn-qingdao.aliyuncs.com/_assets/wxapp/reader/user/user_bookshelf_icons.png?11") -182px
            2px no-repeat;
          background-size: 205px auto;
          margin-right: 15px;
        }
        .filter-item.active .icon {
          background-position: -121px -5px;
        }

        .separator {
          height: 1px;
          width: 365px;
          margin-left: 15px;
          background: rgba(0, 0, 0, 0.08);
        }
      }
    }
  }

  .list {
    margin-top: 10px;
    padding: 0 10px;
    &.fixed {
      padding-top: 25px;
    }
    .list-item {
      background-color: #fff;
      border-radius: 5px;
      padding: 12px 17px 10px;
      margin-bottom: 10px;
      .top-wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-bottom: 10px;
        .pet-info {
          display: flex;
          align-items: center;
          .avatar {
            width: 40px;
            height: 40px;
            border-radius: 50%;
            margin-right: 5px;
            overflow: hidden;
          }
          .info-text {
            .title {
              font-weight: bold;
              position: relative;
              padding-left: 16px;
              color: #000;
              font-size: 14px;
              &::before {
                position: absolute;
                top: 2px;
                left: 0;
                content: "";
                width: 13px;
                height: 15px;
                background: url("@{img-baseurl}female.png") center center
                  no-repeat;
                background-size: 100% auto;
              }
              &.male::before {
                background-image: url("@{img-baseurl}male.png");
              }
            }
            .nick {
              font-size: 11px;
              color: #ff8c25;
            }
          }
        }
        .adopt-state {
          position: relative;
          top: 4px;
          width: 53px;
          height: 20px;
          background-size: 100% 100%;
          background-repeat: no-repeat;
          &.waiting_adopt {
            /*display: none;*/
            background-image: url("@{img-baseurl}wait_adopt.png?1");
          }
          &.adopted {
            background-image: url("@{img-baseurl}adopted.png?1");
          }
        }
      }
      .desc {
        font-size: 13px;
        line-height: 1.6;
        color: #595959;
        margin-bottom: 10px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        text-align: left;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
      }
      .img-list {
        display: flex;
        margin-bottom: 10px;

        .animal-picture {
          width: 100px;
          height: 100px;
          margin-right: 10px;
          &:last-child {
            margin: 0;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 11px;
        color: #949494;
        .left {
          .city {
            position: relative;
            padding-left: 15px;
            &::before {
              position: absolute;
              top: 0;
              left: 0;
              content: "";
              width: 10px;
              height: 12.5px;
              background: url("@{img-baseurl}location.png") center center
                no-repeat;
              background-size: 100% auto;
            }
          }
        }
        .right {
          display: flex;
          align-items: center;
          .share {
            position: relative;
            padding-left: 21px;
            font-size: 11px;
            color: #949494;
            &::before {
              position: absolute;
              top: -1px;
              left: 0;
              content: "";
              width: 18px;
              height: 16px;
              background: url("@{img-baseurl}share.png?1") center center
                no-repeat;
              background-size: 100% auto;
            }
          }
        }
        text {
          margin-right: 15px;
        }
      }
    }
  }
  .loading {
    text-align: center;
    color: rgba(0, 0, 0, 0.5);
    font-size: 14px;
    padding: 10px auto;
  }

  .bottom {
    font-size: 12px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999;
    .c-name {
      margin-right: 10px;
    }
  }
}
</style>
